import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  getGiftById,
  getGiftsList,
  listGifts,
  purchaseGift,
} from "../redux/actions/profile";
import { useParams, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const GIFT_SIZE = 100;

export default function ARGiftScene() {
  const PLACED_GIFTS_KEY = "ar_placed_gifts";

  const [cameraStream, setCameraStream] = useState(null);
  const [draggingGift, setDraggingGift] = useState(null);
  const [dragIndex, setDragIndex] = useState(null);
  const [dragPos, setDragPos] = useState({ x: 0, y: 0 });
  const [placedGifts, setPlacedGifts] = useState([]);
  const [giftsList, setGiftsList] = useState([]);
  const [otherUsersGifts, setOtherUsersGifts] = useState([]);

  const [searchParams] = useSearchParams();
  const { med_id } = useParams();
  const gift = searchParams.get("gift");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  /* ================= CAMERA ================= */
  useEffect(() => {
    navigator.mediaDevices
      .getUserMedia({
        video: { facingMode: "environment" },
        audio: false,
      })
      .then(setCameraStream)
      .catch(console.error);
  }, []);

  /* ================= LOCAL STORAGE ================= */
  useEffect(() => {
    const saved = localStorage.getItem(PLACED_GIFTS_KEY);
    if (saved) setPlacedGifts(JSON.parse(saved));
  }, []);

  /* ================= FETCH GIFTS ================= */
  useEffect(() => {
    dispatch(getGiftsList(med_id))
      .unwrap()
      .then((res) => res?.status === 200 && setOtherUsersGifts(res.data || []))
      .catch(console.error);
  }, [med_id]);

  // useEffect(() => {
  //   if (!gift) return;
  //   dispatch(getGiftById(gift))
  //     .unwrap()
  //     .then((res) => res?.status === 200 && setGiftsList(res.data || []))
  //     .catch(console.error);
  // }, [gift]);

  useEffect(() => {
    const fetchGifts = async () => {
      try {
        const response = await dispatch(listGifts());
        if (response.payload) {
          setGiftsList(response.payload?.data?.gifts);
        }
      } catch (error) {
        console.error("Error fetching gifts:", error);
      }
    };

    fetchGifts();
  }, [dispatch]);

  /* ================= POSITION ================= */
  const clampPosition = (clientX, clientY) => {
    const container = document.getElementById("camera-container");
    if (!container) return { x: 0, y: 0 };

    const rect = container.getBoundingClientRect();

    let x = clientX - rect.left;
    let y = clientY - rect.top;

    x = Math.max(GIFT_SIZE / 2, Math.min(x, rect.width - GIFT_SIZE / 2));
    y = Math.max(GIFT_SIZE / 2, Math.min(y, rect.height - GIFT_SIZE / 2));

    return { x, y };
  };

  /* ================= DRAG ================= */
  const handleMouseMove = (e) => {
    if (!draggingGift) return;
    setDragPos(clampPosition(e.clientX, e.clientY));
  };

  const handleTouchMove = (e) => {
    if (!draggingGift) return;
    const t = e.touches[0];
    setDragPos(clampPosition(t.clientX, t.clientY));
  };

  const handleDrop = () => {
    if (!draggingGift) return;

    const giftData = giftsList.find((g) => g.image === draggingGift);
    const next = {
      src: draggingGift,
      x: dragPos.x,
      y: dragPos.y,
      giftId: giftData?._id,
      amount: giftData?.amount || 0,
    };

    if (dragIndex !== null) {
      const updated = [...placedGifts];
      updated[dragIndex] = next;
      setPlacedGifts(updated);
    } else {
      setPlacedGifts([...placedGifts, next]);
    }

    setDraggingGift(null);
    setDragIndex(null);
  };

  const startDragPlacedGift = (src, index, x, y) => {
    setDraggingGift(src);
    setDragIndex(index);
    setDragPos({ x, y });
  };

  const handleRemoveGift = (index) =>
    setPlacedGifts(placedGifts.filter((_, i) => i !== index));

  /* ================= PURCHASE ================= */
  const handlePurchaseGift = async () => {
    try {
      localStorage.setItem(PLACED_GIFTS_KEY, JSON.stringify(placedGifts));
      
      const giftIds = placedGifts.map(gift => gift.giftId).filter(Boolean);
      
      const payload = {
        gift_id: giftIds,
        medallion_id: med_id,
        total: placedGifts.length,
      };

      const res = await dispatch(purchaseGift(payload)).unwrap();

      if (res?.link) window.location.href = res.link;
      else toast.success(res?.message || "Added to cart");
    } catch {
      toast.error("Purchase failed");
    }
  };

  const calculateTotal = () => {
    const giftCounts = {};
    placedGifts.forEach((gift) => {
      const key = gift.giftId || gift.src;
      giftCounts[key] = (giftCounts[key] || 0) + 1;
    });

    return Object.entries(giftCounts).reduce((total, [giftKey, count]) => {
      const gift = giftsList.find(
        (g) => g._id === giftKey || g.image === giftKey
      );
      return total + (gift?.amount || 0) * count;
    }, 0);
  };

  const total = calculateTotal();

  /* ================= RENDER ================= */
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div class="commn-page-back" onClick={() => navigate(-1)}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
        >
          <path
            d="M10 20.0003L8.93934 21.061L7.87868 20.0003L8.93934 18.9397L10 20.0003ZM30 18.5003C30.8284 18.5003 31.5 19.1719 31.5 20.0003C31.5 20.8288 30.8284 21.5003 30 21.5003V18.5003ZM15.606 27.7277L8.93934 21.061L11.0607 18.9397L17.7273 25.6063L15.606 27.7277ZM8.93934 18.9397L15.606 12.273L17.7273 14.3943L11.0607 21.061L8.93934 18.9397ZM10 18.5003H30V21.5003L10 21.5003L10 18.5003Z"
            fill="#40413A"
          ></path>
        </svg>
        <p>Back</p>
      </div>
      <div
        id="camera-container"
        style={{
          width: "80%",
          height: "100%",
          position: "relative",
          overflow: "hidden",
        }}
        onMouseMove={handleMouseMove}
        onMouseUp={handleDrop}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleDrop}
      >
        {/* CAMERA */}
        {cameraStream && (
          <video
            autoPlay
            playsInline
            muted
            ref={(v) => v && (v.srcObject = cameraStream)}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              pointerEvents: "none", // 🔥 critical fix
            }}
          />
        )}

        {/* PLACED GIFTS */}
        {placedGifts.map(
          (g, i) =>
            dragIndex !== i && (
              <div
                key={i}
                style={{
                  position: "absolute",
                  top: g.y - GIFT_SIZE / 2,
                  left: g.x - GIFT_SIZE / 2,
                  width: GIFT_SIZE,
                  height: GIFT_SIZE,
                  zIndex: 10,
                }}
              >
                <button
                  onClick={() => handleRemoveGift(i)}
                  style={{
                    position: "absolute",
                    top: -6,
                    right: -6,
                    width: 25,
                    height: 26,
                    borderRadius: "50%",
                    border: "none",
                    background: "rgba(0,0,0,0.7)",
                    color: "#fff",
                    zIndex: 20,
                  }}
                >
                  ✕
                </button>

                <img
                  src={g.src}
                  alt=""
                  style={{ width: "100%", height: "100%", cursor: "grab" }}
                  onMouseDown={() => startDragPlacedGift(g.src, i, g.x, g.y)}
                  onTouchStart={() => startDragPlacedGift(g.src, i, g.x, g.y)}
                />
              </div>
            )
        )}

        {/* OTHER USERS GIFTS */}
        {otherUsersGifts.map((g, i) =>
          g?.codes?.map((c, j) => (
            <img
              key={`${i}-${j}`}
              src={c.src}
              alt=""
              style={{
                position: "absolute",
                top: c.y - GIFT_SIZE / 2,
                left: c.x - GIFT_SIZE / 2,
                width: GIFT_SIZE,
                height: GIFT_SIZE,
                pointerEvents: "none",
                zIndex: 5,
              }}
            />
          ))
        )}

        {/* DRAG PREVIEW */}
        {draggingGift && (
          <img
            src={draggingGift}
            alt=""
            style={{
              position: "absolute",
              top: dragPos.y - GIFT_SIZE / 2,
              left: dragPos.x - GIFT_SIZE / 2,
              width: GIFT_SIZE,
              height: GIFT_SIZE,
              pointerEvents: "none", // 🔥 critical fix
              zIndex: 15,
            }}
          />
        )}

        {/* GIFTS SLIDER */}
        <div
          style={{
            position: "absolute",
            bottom: 10,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            zIndex: 20,
          }}
        >
          <div
            className="slider-of-gifts"
            style={{ width: "80%", maxWidth: "400px" }}
          >
            <Slider
              dots={false}
              arrows={true}
              infinite={false}
              speed={500}
              slidesToShow={Math.min(giftsList.length, 3)}
              slidesToScroll={1}
              centerMode={false}
            >
              {giftsList.map((item) => (
                <div
                  key={item._id}
                  style={{
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={item.image}
                    alt=""
                    style={{
                      width: GIFT_SIZE,
                      height: GIFT_SIZE,
                      cursor: "grab",
                    }}
                    draggable={false}
                    onMouseDown={() => setDraggingGift(item.image)}
                    onTouchStart={() => setDraggingGift(item.image)}
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>

        {/* PAYMENT (TOP LAYER) */}
        {placedGifts.length > 0 && (
          <div
            style={{
              position: "absolute",
              bottom: 0,
              right: 0,
              margin: 12,
              zIndex: 1000,
              pointerEvents: "auto",
            }}
          >
            <div className="bg-white rounded p-3 mb-2 shadow">
              <div>Total Items: {placedGifts.length}</div>
              <div style={{ fontWeight: "bold" }}>
                Total: £{total.toFixed(2)}
              </div>
            </div>
            <button
              className="button-common-summer btn w-100"
              onClick={handlePurchaseGift}
            >
              Pay Now
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
